export default __webpack_public_path__ + "static/media/Erick.b5d42580.jpg";